<template>
    <div class="slide">
        <go-back />
        <div class="slide-container">
            <div v-if="personTwoExists">
                <div class="question">
                    Just a few more questions to help me formulate your plan. Do either of you have a <span>pension</span>?
                </div>

                <div class="answer answer-col">
                    <span class="alternative" @click="next('all')">Both of us</span>
                    <span class="alternative" @click="next('you')">Only me</span>
                    <span class="alternative" @click="next('spouse')">Only {{ personTwo.name }}</span>
                    <span class="alternative" @click="next('no')">None of us</span>
                </div>
            </div>

            <div v-else>
                <div class="question">
                    Just a few more questions to help me formulate your plan. Do you have a <span>pension</span>?
                </div>

                <div class="answer answer-col">
                    <span class="alternative" @click="next('you')">Yes</span>
                    <span class="alternative" @click="next('no')">No</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import GoBack from "./GoBack";
    export default {
        name: 'HavePensions',
        components: {
            GoBack
        },
        methods: {
            next( who ) {
                if ( who === 'no' ) {
                    this.$router.push({ name: 'HaveIncome' });
                } else {
                    this.$router.push({ name: 'Pension', params:{ havePensions: who } });
                }
            }
        },
        computed: {
            ...mapGetters('individuals', [
                'personTwo',
                'personTwoExists',
            ]),
        }
    }
</script>
